import { computed, makeObservable } from 'mobx';

import dateService from '@gem/services/date-service';

import Entities from 'STORE';

export class BackgroundStream {
  groupId;
  channelId;
  status;
  startTs;

  constructor(groupId, channelId, status, startTs = dateService.now().valueOf()) {
    makeObservable(this);
    this.groupId = groupId;
    this.channelId = channelId;
    this.status = status;
    this.startTs = startTs;
  }

  @computed
  get group() {
    return Entities.GroupsStore.getGroupById(this.groupId);
  }
}
